import {
  ActionTypes,
  ResetAppAction,
  SetReadyAction,
  MustUpdateAction,
  SetAppVisibilityAction,
  MustUpdatePointsAction,
  MustUpdateSummaryAction,
} from './types';

const resetApp = (): ResetAppAction => ({
  type: ActionTypes.RESET_APP,
});
const setReady = (payload: boolean): SetReadyAction => ({
  type: ActionTypes.SET_READY,
  payload,
});
const mustUpdate = (payload: boolean): MustUpdateAction => ({
  type: ActionTypes.SET_MUST_UPDATE,
  payload,
});
const setAppVisibility = (payload: string | null): SetAppVisibilityAction => ({
  type: ActionTypes.SET_APP_VISIBILITY,
  payload,
});
const mustUpdatePoints = (payload: boolean): MustUpdatePointsAction => ({
  type: ActionTypes.MUST_UPDATE_POINTS,
  payload,
});
const mustUpdateSummary = (payload: boolean): MustUpdateSummaryAction => ({
  type: ActionTypes.MUST_UPDATE_SUMMARY,
  payload,
});

export { resetApp, setReady, mustUpdate, setAppVisibility, mustUpdatePoints, mustUpdateSummary };
